import React from "react";
import { TbBrandFiverr } from "react-icons/tb";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FaSquareUpwork } from "react-icons/fa6";

const socials = [
  {
    href: "https://www.upwork.com/freelancers/~01efd5ce631be90f37",
    Icon: FaSquareUpwork,
    label: "Upwork",
  },
  {
    href: "https://www.fiverr.com/hamzaamehboob",
    Icon: TbBrandFiverr,
    label: "Fiverr",
  },
  {
    href: "https://github.com/hamxamehboob",
    Icon: FaGithub,
    label: "GitHub",
  },
  {
    href: "https://www.linkedin.com/in/hamza-mehboob-843815233/",
    Icon: FaLinkedinIn,
    label: "LinkedIn",
  },
];

const Footer = () => {
  return (
    <footer className="relative px-6 md:px-12 lg:px-24 py-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/45 text-center lg:text-left">
          Crafted with care by{" "}
          <span className="text-gradient-aurora font-medium">
            Hamza Mehboob
          </span>
          .
        </p>

        <div className="flex items-center gap-2">
          {socials.map(({ href, Icon, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="w-9 h-9 rounded-full flex items-center justify-center bg-white/[0.04] border border-white/10 text-white/65 hover:text-white hover:border-aurora-teal/40 hover:bg-white/[0.06] transition-all"
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
